<template>
  <div class="point">
    <div class="point__head">
      <div class="point-board">
        <div class="point-board__text">保有ポイント</div>
        <div class="point-board__point">
          {{ filterdPoint | addComma }}<span class="point-board__unit">pt</span>
        </div>
        <div v-if="expirationDate" class="point-board__expire">{{ expirationDate }}まで有効</div>
      </div>
    </div>
    <point-enough
      v-if="isPointEnough()"
      :services="availableServices"
      :point="point"
    />
    <point-not-enough v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PointEnough from './PointEnough'
import PointNotEnough from './PointNotEnough'

export default {
  name: 'UserAccountPoint',
  components: {
    PointEnough,
    PointNotEnough
  },
  data () {
    return {
      // ポイントを桁区切りのある文字列に
      filterdPoint: '',
      availableServices: this.services,
    }
  },
  props: {
    // 保有ポイント
    point: {
      type: Number,
      default: 0
    },
    // ポイントを利用できるサービス
    services: {
      type: Array,
      default () {
        return []
      }
    },
  },
  computed: {
    // ポイントの有効期限を変換して返す
    expirationDate() {
      const val = Number(this.userInfo.user_point_expire_at) * 1000
      if (Number(val) > 0) {
        return window.moment(val).format('YYYY年M月D日')
      } else {
        return false
      }
    },
    ...mapState({
      userInfo: state => state.account.user,
      subscInfo: state => state.account.subscription,
    })
  },
  created () {
    this.filterdPoint = String(this.point)
    if (/^(1|3)$/.test(this.subscInfo.status)) {
      this.availableServices.splice(1, 1)
    }
  },
  methods: {
    /**
     * コンテンツの出し分け判定
     * @return {Boolean} true 利用できるサービスを表示
     */
    isPointEnough () {
      // しきい値の配列作る
      const thresholdsArray = this.services.map(item => item.thresholds)
      // 保有ポイントがある
      const condition1 = this.point > 0
      // 保有ポイントが、サービスのいづれかの価格（しきい値）以上である
      const condition2 = this.point >= Math.min.apply(null, thresholdsArray)
      return condition1 && condition2
    }
  }
}</script>

<style lang="scss" scoped>
@import '../../../../sass/commons/commonVariables.scss';

.point {
  color: $col_base_black;
  line-height: 1.6;
  margin-bottom: 50px;
  &__head {
    padding: 23px 4px;
  }
}
.point-board {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 20px;
  background: $col_def_gradient;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  color: $col_white;
  line-height: 1;
  &__text {
    font-weight: bold;
    font-size: 13px;
    flex-shrink: 0;
    padding-right: 10px;
  }
  &__point {
    font-size: 36px;
    font-family: "DIN Alternate";
    word-break: break-all;
    text-align: right;
  }
  &__unit {
    font-size: 26px;
  }
  &__expire {
    flex: 1 1 100%;
    text-align: right;
    font-size: 11px;
    line-height: 16px;
    margin: 10px 0 -7px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/User/UserAccountPoint.vue